import React from 'react';
import * as Sentry from '@sentry/nextjs';
import copy from 'copy-to-clipboard';
import NextImage from 'next/image';
import toast from 'react-hot-toast';
import QRCode from 'react-qr-code';
import { getCoachPageUrl } from 'constants/pages';
import { useGetCurrentUser } from 'hooks/useGetCurrentUser';
import BounceLogoSplashShadow from 'svg/BounceLogoSplashShadow';
import CloseIcon from 'svg/CloseIcon';
import Button from 'components/Button';
import Modal from 'components/modals/Modal';

interface Props {
  isOpen: boolean;
  closeModal: (value: boolean) => void;

  title: string;
  buttonText?: string;
}

const INVITE_BG_IMAGE = '/images/invite/invite-bg.png';

const ModalReviews = ({ isOpen, closeModal, title }: Props) => {
  const { user } = useGetCurrentUser();
  const profileUrl = `${process.env.APP_URL}${getCoachPageUrl(user?.username || user?.id)}`;

  return (
    <>
      <Modal
        isOpen={isOpen}
        handleClose={() => closeModal(false)}
        classNameMaxWidth="md:max-w-[76.25rem] xs:max-w-md"
      >
        <main className="relative flex w-full flex-col">
          <div className="flex flex-row items-end justify-end">
            <button
              className="absolute right-3 top-2.5 p-0.5 text-color-text-lightmode-primary dark:text-color-text-darkmode-primary"
              type="button"
              onClick={() => closeModal(false)}
            >
              <CloseIcon className="h-6 w-6" />
            </button>
          </div>

          <div className="mt-[6.5rem] px-6">
            <div className="grid grid-cols-2 gap-4">
              <div>Rating</div>
              <div>Reviews</div>
            </div>

            <div className="flex w-full items-center justify-center gap-4 xs:mb-14 xs:flex-col md:flex-row">
              <Button
                onClick={() => {
                  try {
                    copy(profileUrl);
                    toast.success('Invite player link copied');
                  } catch (error) {
                    Sentry.captureException(error);
                    toast.error('Could not copy');
                  }
                }}
                variant="primary"
                label="Copy link"
                sizeDesktop="lg"
                sizeMobile="md"
                className="xs:h-10 xs:w-full md:h-full md:w-44"
              />
            </div>
          </div>
        </main>
      </Modal>
    </>
  );
};

export default ModalReviews;
